import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Storage from 'vue-ls'
import ElementUI from 'element-ui'
import VueI18n from "vue-i18n"
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import moment from "moment";
import globle from './utils/globle'
import '@/icons'
import "element-ui/lib/theme-chalk/index.css"
import './permission'
import '@a/css/index.css'
import '@a/css/navMenu.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueI18n)

Vue.filter("global_filter", function (value, type = "YYYY-MM-DD hh:mm:ss") {
  return moment(value).format(type);
});
Vue.prototype.apiUrl = '/api/' //测试
// Vue.prototype.apiUrl = 'http://10.4.248.129:9200' //测试

//注册全局方法
Object.keys(globle).forEach(val => {
  Vue.prototype['$' + val] = globle[val]
})

var options = {
  namespace: 'customer_', // key键前缀
  name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
  storage: 'local', // 存储名称: session, local, memory
};
Vue.use(Storage, options)

if (Vue.ls.get('lang') && Vue.ls.get('lang') == 'CN') {
  locale.use(zhLocale)
} else {
  locale.use(enLocale)
}

const i18n = new VueI18n({
  locale: Vue.ls.get('lang') || "EN",
  messages: {
    'CN': require('@/lang/zh'),   // 中文语言包
    'EN': require('@/lang/en')    // 英文语言包
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
